import React from 'react';
import './EventsIntro.css';

const EventsIntro = () => {
  return (
    <section className="events-intro-section">
      <div className="events-intro-container">
        <h2>CRISHI Events</h2>
        <p>
          CRISHI Events offers an elite platform for networking and business growth, catering to professionals from the agricultural and allied industries worldwide. Our gatherings enable industry pioneers to exchange ideas, share expertise, and display innovative products and services. Engage with peers, build lasting partnerships, and drive your business success with CRISHI Events.
        </p>
      </div>
    </section>
  );
};

export default EventsIntro;